<template>
    <router-link :to="mapRoute" class="d-flex px-3 py-2 comment-notification e3-notification-row">
        <div class="profile-image-container">
            <ProfileImage :image-url="notification.creator.profile_picture" :name="notification.creator.name" size="sm"/>
        </div>
        <div class="d-flex flex-column ml-2 w-100">
            <template v-if="data.type === 'new'">
                <i18n path="Notification - New card comment" tag="span">
                    <span place="user" class="font-weight-bold">{{ data.employee_name }}</span>
                    <router-link place="child" :to="mapRoute">{{ data.child_name }}</router-link>
                </i18n>
            </template>
            <template v-else-if="data.type === 'resolved'">
                <i18n path="Notification - Card comment resolved" tag="span">
                    <span place="user" class="font-weight-bold">{{ data.employee_name }}</span>
                    <router-link place="child" :to="mapRoute">{{ data.child_name }}</router-link>
                    <span place="comment" class="text-muted">{{ truncate(stripHtmlTags(data.comment_preview || ''), 30) }}</span>
                </i18n>
            </template>
        </div>
    </router-link>
</template>

<script>
import { stripHtmlTags, truncate } from '@/filters';

export default {
    name: 'CommentNotification',
    props: {
        notification: Object
    },
    computed: {
        data() {
            return this.notification.data;
        },
        mapRoute() {
            const { child_id, employee_id, field_id, id, map_id } = this.data;
            return { name: 'child.map', params: { child_id, employee_id, field_id, map_id, comment_id: id } };
        }
    },
    methods: {
        stripHtmlTags, // TODO: Vue3 remove
        truncate // TODO: Vue3 remove
    }
};
</script>

<style scoped lang="scss">
@import "@common/styles/variables/_variables.scss";

.comment-notification {
    color: $text-black;

    &:hover {
        text-decoration: none;
    }
}
</style>
